import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './Core/Auth/Service/auth.service';
import { SessionService } from './Core/Session/session.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'campus-v2';

  constructor(
    private authService: AuthService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    // Start session monitoring if user is already authenticated
    if (this.authService.isAuthenticated()) {
      this.sessionService.startMonitoring();
    }
  }
}
